import { ApiRequest, GetBaseServiceFunctions } from '../baseService'

const BaseStateRoute = 'app/talking-point/state'
const baseStateFunctions = GetBaseServiceFunctions(BaseStateRoute)
const API = { ...baseStateFunctions }
export default API
